export default "__VITE_ASSET__CXG6xR6U__"